/**
 * Updater service – kebutuhan app info & update manifest dipetakan ke repository.
 */

import { appendLog } from '../../logStore.js';
import * as repo from '../repository.js';

/**
 * Ambil app info dari /appinfo.json.
 * @returns {Promise<{ id: string, version: string, raw?: object }>}
 */
export async function getAppInfo() {
  try {
    return await repo.fetchAppInfo();
  } catch (e) {
    try {
      appendLog({
        type: 'error',
        detail: { event: 'update-appinfo-failed', message: String(e?.message || e) },
      });
    } catch {}
    return { id: '', version: '0.0.0' };
  }
}

/**
 * Ambil update manifest (coba extraUrls lalu default).
 * @param {string[]} [extraUrls]
 * @returns {Promise<{ version: string, url?: string, ipkUrl?: string }|null>}
 */
export async function fetchUpdateManifest(extraUrls = []) {
  return repo.fetchUpdateManifestRaw(extraUrls);
}
